import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { faMessage, faShareNodes } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";
import { Button } from "@/components/Button/Button";
import { ButtonColor, ButtonSize } from "@/components/Button/types";

import { SignpostCard } from "../../components/SignpostCard/SignpostCard";

/**
 * Shown on the Outbox campaign tab when the selected lead has no campaign behind it —
 * their messages went or go out individually via Chat, so instead of an empty sequence
 * the card points to the Chat tab.
 */
export const OutboxNoCampaignSignpost: FunctionComponent<{ onOpenChat: () => void }> = ({
	onOpenChat,
}) => {
	const { t } = useTranslation();

	return (
		<SignpostCard
			actions={
				<div className="w-fit">
					<Button
						color={ButtonColor.BRAND}
						image={<Icon className="mr-2" icon={faMessage} />}
						size={ButtonSize.S}
						title={t("messages.openChat")}
						onClick={onOpenChat}
					/>
				</div>
			}
			description={t("messages.outboxNoCampaignDesc")}
			icon={faShareNodes}
			title={t("messages.outboxNoCampaignTitle")}
		/>
	);
};
